/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { manejadorDialogoGlobal } from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IFlujosEtapasCompuesta from 'Infotrack@Modelos/smartStock/flujosEtapas/entidades/flujosEtapasCompuesta';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import FlujosEtapasCM from '../controladorModelo/flujosEtapasCM';
import { acciones, IEstadoAPropiedades, IEstadoFlujosEtapas } from '../interfaces';
import TablaFlujosEtapasVista from '../vista/tablaFlujosEtapasVista';

const flujosEtapasCM = new FlujosEtapasCM();

const TablaFlujosEtapasCV: React.FunctionComponent<IEstadoAPropiedades> = ({ EmpresaId }) => {
    const [flujosEtapasCompuestas, setFlujosEtapasCompuestas] = React.useState<IFlujosEtapasCompuesta[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoFlujosEtapas>();

    React.useEffect(() => {
        if (recargarTabla) {
            consultarFlujosEtapas();
            dispatch({ type: acciones.RECARGAR_TABLA });
        }
    }, [recargarTabla]);

    const consultarFlujosEtapas = async () => {
        setFlujosEtapasCompuestas(await flujosEtapasCM.consultarFlujosEtapas(EmpresaId));
    };

    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadFlujosEtapas?: IFlujosEtapasCompuesta) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadFlujosEtapas, tipoFormulario } });
    };

    const confirmarEliminacion = (flujosEtapas: IFlujosEtapasCompuesta) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarFlujosEtapas(flujosEtapas),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarFlujosEtapas = (flujosEtapas: IFlujosEtapasCompuesta) => {
        manejadorDialogoGlobal({ estado: false });
        flujosEtapasCM.eliminarFlujosEtapas(flujosEtapas).then(() => {
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <TablaFlujosEtapasVista
            flujosEtapass={flujosEtapasCompuestas}
            consultarFlujosEtapas={consultarFlujosEtapas}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

const estadoAPropiedades = ({ estadoAutenticacion: { usuarioInformacion } }: IEstadoGlobal): IEstadoAPropiedades => ({
    EmpresaId: usuarioInformacion!.IdEmpresa,
});

export default connect<IEstadoAPropiedades, null, any, IEstadoGlobal>(estadoAPropiedades, null)(TablaFlujosEtapasCV);
